import { render, staticRenderFns } from "./CyberRiskAwareDetails.vue?vue&type=template&id=7a865274&"
import script from "./CyberRiskAwareDetails.vue?vue&type=script&lang=js&"
export * from "./CyberRiskAwareDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports